import React, { useEffect, useState } from 'react'
import { useStateValue } from '../../StateProvider';
import { getDefaultValue } from '../../utils';
import { KT_COURSE_PARTICIPATION_CHANGED } from '../../utils/contestParticipationEvents';
import Constants from '../../utils/Constants';
import { ContestHttpService } from '../../utils/http/contest_http_service';
import { loadProfile } from '../../utils/Network';
import { AcceptRulesBlock } from '../dialogs/ModalAcceptRules';
import ModalCompleteProfile from '../dialogs/ModalCompleteProfile';
import ModalUnroll from '../dialogs/ModalUnroll';

function ParticipateButtonSingle({ course, courseTitle, hideUnrollWhenEnrolled = false, ...props }) {
    const [courseParticipant, setCourseParticipant] = useState(null)
    const [termsAccepted, setTermsAccepted] = useState(false);
    const [rulesAcceptError, setRulesAcceptError] = useState(null);
    const [unrollModalIsOpen, setUnrollModalIsOpen] = useState(false);

    const [completeProfileModalIsOpen, setCompleteProfileModalIsOpen] = useState(false);
    const [loading, setLoading] = useState(null);
    const [error, setError] = useState(null);
    const [profile, setProfile] = useState(null);

    const [{ translations }] = useStateValue();
    const translate = (str) => {
        if (!translations) return str;
        var translate = translations.find(x => x.key == str);

        if (translate) return getDefaultValue(translate);
        else return "#" + str;
    };

    useEffect(() => {
        _getData()

        return () => {

        }
    }, [])

    const notifyParticipationChanged = () => {
        try {
            window.dispatchEvent(
                new CustomEvent(KT_COURSE_PARTICIPATION_CHANGED, {
                    detail: { courseId: course },
                })
            );
        } catch (_) {
            /* ignore */
        }
        if (props.onParticipationChange) props.onParticipationChange();
    };

    const _getData = async () => {
        var query = "?course=" + encodeURIComponent(course)
        ContestHttpService.loadCourseParticipant(query).then((data) => {
            if (data.results) {
                setCourseParticipant(data.results[0])
            }

        });

        _getProfile()
    }

    const _getProfile = () => {
        loadProfile().then((profile) => {
            setProfile(profile);
            setLoading(false);
        }
        )
    }

    const participate = () => {
        setLoading(translate("Please wait..."))
        let body = {
            "course": course
        }
        ContestHttpService.participate(body).then(data => {
            setError("")
            setLoading(false)
            if (data.error) {
                // window.location.reload()
                setError(translate("You already participated in this competition"))

            }
            else if (data.Error) {
                setError(translate("You cannot participate in this course again"))
            }
            else {
                setCourseParticipant(data)
                if (props.onSuccess) props.onSuccess(data)
                notifyParticipationChanged()
            }

        })
    }

    const _handleClick = () => {
        setRulesAcceptError(null);
        if (profile && !profile.country_id) {
            setCompleteProfileModalIsOpen(true)
        } else {
            if (courseParticipant) {
                if (!hideUnrollWhenEnrolled) setUnrollModalIsOpen(true)
            }
            else {
                if (!termsAccepted) {
                    setRulesAcceptError(translate("Please accept terms and condititions"))
                    return;
                }
                participate()
            }
        }
    }



    return (
        <div>
            {!courseParticipant && (
                <AcceptRulesBlock
                    checked={termsAccepted}
                    onCheckedChange={(v) => {
                        setTermsAccepted(v);
                        if (v) setRulesAcceptError(null);
                    }}
                    rulesError={rulesAcceptError}
                    inputId="participate-inline-rules"
                />
            )}
            {courseParticipant && hideUnrollWhenEnrolled ? (
                <p className="contest-participation__joined-hint my-10 py-10" role="status">
                    {translate(Constants.ContestJoinedWaitNextStepsMessage)}
                </p>
            ) : (
                <button type="button"
                    onClick={_handleClick}
                    disabled={Boolean(loading)}
                    aria-busy={Boolean(loading)}
                    className="btn btn-primary btn-block contest-participation__submit font-weight-bold width-240 text-3 my-10 py-10"
                >
                    {courseParticipant &&
                        <>
                            <i className="fas fa-user-minus op-7"></i>&nbsp;&nbsp;
                            {translate('Unroll')}
                        </>
                    }
                    {!courseParticipant &&
                        <>
                            <i className={loading ? "fas fa-spinner fa-spin" : "fas fa-trophy"}></i>&nbsp;
                            {loading ? translate('Please wait...') : translate('Participate')}
                        </>
                    }
                </button>
            )}
            {error &&
                <>
                    {translate(error)}
                </>
            }
            <ModalCompleteProfile
                isOpen={completeProfileModalIsOpen}
                message={Constants.ContestCompleteYourProfileMessage}
                setIsOpen={setCompleteProfileModalIsOpen}
                onSuccess={() => {
                    loadProfile().then((p) => {
                        setProfile(p);
                    });
                }}
            />
            {!hideUnrollWhenEnrolled && (
                <ModalUnroll
                    course={course}
                    courseTitle={courseTitle}
                    isOpen={unrollModalIsOpen}
                    setIsOpen={setUnrollModalIsOpen}
                    courseParticipant={courseParticipant}
                    onSuccess={() => {
                        setCourseParticipant(null);
                        setUnrollModalIsOpen(false);
                        notifyParticipationChanged();
                    }}
                />
            )}
        </div>
    )
}

export default ParticipateButtonSingle
